import React from 'react';
import { Button, Typography, Space } from 'components';
import { CameraOutlined, FullscreenOutlined } from '@ant-design/icons';
import styles from './IdentifierImageBox.module.scss';

const { Text } = Typography;

interface IdentifierImageBoxProps {
  isIdentifying: boolean;
  identificationImage: { url: string; fileName?: string } | null;
  onPreview: (url: string) => void;
  onOpenCamera: () => void;
}

export const IdentifierImageBox: React.FC<IdentifierImageBoxProps> = ({
  isIdentifying,
  identificationImage,
  onPreview,
  onOpenCamera,
}) => {
  return (
    <div className={styles.container}>
      {/* Uploading/Identifying State */}
      {isIdentifying && (
        <Space direction="vertical" size={8} align="center" style={{ width: '100%', height: '100%' }}>
          <div className={styles.loader} />
          <Text className={styles.uploadingText}>Uploading...</Text>
        </Space>
      )}

      {/* Image Loaded State */}
      {!isIdentifying && identificationImage && (
        <>
          <img src={identificationImage.url} alt="Identified item" className={styles.image} />
          <div className={styles.actions}>
            <Button
              type="text"
              icon={<FullscreenOutlined />}
              size="small"
              onClick={() => onPreview(identificationImage.url)}
              className={styles.actionBtn}
            />
          </div>
        </>
      )}

      {/* Empty State - Clickable */}
      {!isIdentifying && !identificationImage && (
        <div className={styles.emptyState} onClick={onOpenCamera}>
          <Space direction="vertical" size={8} align="center">
            <CameraOutlined className={styles.cameraIcon} />
            <Text className={styles.clickText}>Click to Scan</Text>
          </Space>
        </div>
      )}
    </div>
  );
};
